function sliderServices () {
    new Swiper('.services .mySwiper', {
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 1200,
        slideToClickedSlide: !0,
        navigation: {
            nextEl: '.services .swiper-button-next',
            prevEl: '.services .swiper-button-prev'
        },
        breakpoints: { 320: { spaceBetween: 10 }, 993: { spaceBetween: 20 } }
    })
}
function planGallery () {
    let e = []
    document.querySelectorAll('.plan__images').forEach((t, i) => {
        t.setAttribute('data-slider-id', i)
        let r = { mySwiper: {}, mySwiper2: {} }
        ;(r.mySwiper = new Swiper(
            `.plan__images[data-slider-id="${i}"] .mySwiper`,
            {
                slidesPerView: 4,
                spaceBetween: 16,
                freeMode: !0
            }
        )),
            (r.mySwiper2 = new Swiper(
                `.plan__images[data-slider-id="${i}"] .mySwiper2`,
                {
                    spaceBetween: 16,
                    slidesPerView: 1,
                    navigation: {
                        nextEl: `.plan__images[data-slider-id="${i}"] .swiper-button-next`,
                        prevEl: `.plan__images[data-slider-id="${i}"] .swiper-button-prev`
                    },
                    thumbs: { swiper: r.mySwiper }
                }
            )),
            (e[i] = r)
    })
}
function sliderPlanMob () {
    var e = new Swiper('.plan-mob .mySwiper', {
        slidesPerView: 1,
        spaceBetween: 20,
        effect: 'fade',
        direction: 'vertical'
    })
    let t = !1
    e.on('slideChange', function () {
        t = e.isEnd
    }),
        e.on('touchEnd', function () {
            if (t && e.touches.diff < 0) {
                const e = document.querySelector('.plan-mob')
                e && e.remove()
            }
        })
}
function sliderAboutAdvantages () {
    new Swiper('.about-advantages .mySwiper', {
        slidesPerView: 3,
        spaceBetween: 20,
        allowTouchMove: !1,
        simulateTouch: !1,
        touchRatio: 0,
        breakpoints: {
            320: {
                slidesPerView: 1.2,
                spaceBetween: 10,
                allowTouchMove: !0,
                simulateTouch: !0,
                touchRatio: 1
            },
            451: {
                slidesPerView: 2,
                spaceBetween: 10,
                allowTouchMove: !0,
                simulateTouch: !0,
                touchRatio: 1
            },
            769: {
                slidesPerView: 2.5,
                spaceBetween: 10,
                allowTouchMove: !0,
                simulateTouch: !0,
                touchRatio: 1
            },
            993: {
                slidesPerView: 3,
                spaceBetween: 20,
                allowTouchMove: !1,
                simulateTouch: !1,
                touchRatio: 0
            }
        }
    })
}
function sliderHouseMain () {
    var e = new Swiper('.house-main__slider .mySwiper', {
        slidesPerView: 4,
        spaceBetween: 16,
        freeMode: !0,
        watchSlidesProgress: !0,
        direction: 'horizontal'
    })
    new Swiper('.house-main__slider .mySwiper2', {
        spaceBetween: 16,
        slidesPerView: 1,
        effect: 'fade',
        thumbs: { swiper: e },
        navigation: {
            nextEl: '.house-main__slider .swiper-button-next',
            prevEl: '.house-main__slider .swiper-button-prev'
        },
        pagination: {
            el: '.house-main__slider .swiper-pagination',
            clickable: !0
        }
    })
}
function sliderArticleNews () {
    new Swiper('.article-news .mySwiper', {
        slidesPerView: 2,
        spaceBetween: 20,
        speed: 1200,
        navigation: {
            nextEl: '.article-news .swiper-button-next',
            prevEl: '.article-news .swiper-button-prev'
        },
        breakpoints: {
            320: { slidesPerView: 1, spaceBetween: 0 },
            577: { slidesPerView: 1.5, spaceBetween: 16 },
            993: { slidesPerView: 2, spaceBetween: 20 }
        }
    })
}
function sliderStages () {
    if (
        'undefined' != typeof Swiper &&
        'undefined' != typeof gsap &&
        'undefined' != typeof ScrollTrigger
    ) {
        var e = new Swiper('.stages__wrap .mySwiper', {
                slidesPerView: 4,
                spaceBetween: 16,
                freeMode: !0
            }),
            t = window.innerWidth < 993,
            u = !!document.querySelector('.about-stages .stages__wrap'),
            i = new Swiper('.stages__wrap .mySwiper2', {
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 1200,
                direction: 'vertical',
                mousewheel: !1,
                allowTouchMove: t,
                autoHeight: !0,
                watchSlidesProgress: !0,
                observer: !0,
                observeParents: !0,
                observeSlideChildren: !0,
                thumbs: { swiper: e },
                pagination: { el: '.stages__pagination', type: 'progressbar' },
                on: {
                    setTranslate: function (swiper) {
                        if (!(typeof window !== 'undefined' && window.innerWidth < 993)) return
                        swiper.slides.forEach(function (slide) {
                            var ap = Math.abs(slide.progress || 0),
                                opacity
                            ap <= 1
                                ? (opacity = 1 - 0.5 * ap)
                                : ap < 2
                                  ? (opacity = 0.5 * (2 - ap))
                                  : (opacity = 0)
                            slide.style.setProperty('transition', 'none')
                            slide.style.setProperty('opacity', String(opacity))
                        })
                    },
                    transitionEnd: function (swiper) {
                        if (!(typeof window !== 'undefined' && window.innerWidth < 993)) return
                        swiper.slides.forEach(function (slide) {
                            slide.style.removeProperty('transition')
                            slide.style.removeProperty('opacity')
                        })
                    },
                    slideChangeTransitionEnd: function (swiper) {
                        if (!(typeof window !== 'undefined' && window.innerWidth < 993)) return
                        swiper.slides.forEach(function (slide) {
                            slide.style.removeProperty('transition')
                            slide.style.removeProperty('opacity')
                        })
                    }
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        speed: 900,
                        spaceBetween: 24,
                        mousewheel: !1,
                        allowTouchMove: !0,
                        touchReleaseOnEdges: !1
                    },
                    993: { slidesPerView: 1, spaceBetween: 0, speed: 1200 }
                }
            })
        if (
            (c(),
            i.on('slideChange', c),
            document.querySelectorAll('.year').forEach(t => {
                t.addEventListener('click', function () {
                    const t = this.getAttribute('data-year')
                    let r = -1
                    e.slides.forEach((e, i) => {
                        e.getAttribute('data-month') === t &&
                            -1 === r &&
                            (r = i)
                    }),
                        -1 !== r && (i.slideTo(r), d(r, !0))
                })
            }),
            !t && !u)
        ) {
            var r = i.slides ? i.slides.length : 0
            if (r && !(r <= 1)) {
                var o,
                    s,
                    a = { idx: 0 },
                    n = -1,
                    l = gsap.timeline({
                        scrollTrigger: {
                            trigger: '.stages__wrap',
                            start: 'top top',
                            end: () => '+=' + window.innerHeight * (r - 1),
                            pin: !0,
                            anticipatePin: 1,
                            scrub: 0.5,
                            snap: {
                                snapTo: 1 / (r - 1),
                                duration: 0.16,
                                ease: 'power1.out',
                                inertia: !1
                            },
                            invalidateOnRefresh: !0,
                            onEnter: () => {
                                i.allowTouchMove = !1
                            },
                            onEnterBack: () => {
                                i.allowTouchMove = !1
                            },
                            onLeave: () => {
                                i.allowTouchMove = !0
                            },
                            onLeaveBack: () => {
                                i.allowTouchMove = !0
                            }
                        }
                    })
                l.to(a, {
                    idx: r - 1,
                    ease: 'none',
                    onUpdate: function () {
                        var e = Math.round(a.idx)
                        e !== n && ((n = e), i.slideTo(e))
                    }
                }),
                    ScrollTrigger.refresh(),
                    i.on('slideChange', function () {
                        d(i.activeIndex, !0)
                    }),
                    (o = document.querySelector('.stages__wrap .mySwiper')) &&
                        o.addEventListener('click', function (e) {
                            var t = e.target.closest('.swiper-slide')
                            if (t) {
                                var r = Array.prototype.slice
                                    .call(o.querySelectorAll('.swiper-slide'))
                                    .indexOf(t)
                                ;-1 !== r && (i.slideTo(r, 0), d(r, !0))
                            }
                        }),
                    (function () {
                        var e = !1,
                            t = document.querySelector('.stages__wrap')
                        t &&
                            t.addEventListener(
                                'wheel',
                                function (o) {
                                    var s = ScrollTrigger.getAll().find(
                                        e => e.trigger === t
                                    )
                                    if (s && s.isActive)
                                        if (e) o.preventDefault()
                                        else if (!(Math.abs(o.deltaY) < 5)) {
                                            if (((e = !0), o.deltaY > 0))
                                                if (i.activeIndex < r - 1)
                                                    i.slideNext()
                                                else {
                                                    var a = s.end
                                                    'number' == typeof a
                                                        ? window.scrollTo({
                                                              top: a + 1,
                                                              left: 0,
                                                              behavior: 'auto'
                                                          })
                                                        : window.scrollBy({
                                                              top:
                                                                  0.5 *
                                                                  window.innerHeight,
                                                              left: 0,
                                                              behavior: 'auto'
                                                          })
                                                }
                                            else if (i.activeIndex > 0)
                                                i.slidePrev()
                                            else {
                                                var n = s.start
                                                'number' == typeof n
                                                    ? window.scrollTo({
                                                          top: n - 1,
                                                          left: 0,
                                                          behavior: 'auto'
                                                      })
                                                    : window.scrollBy({
                                                          top:
                                                              0.5 *
                                                              -window.innerHeight,
                                                          left: 0,
                                                          behavior: 'auto'
                                                      })
                                            }
                                            setTimeout(function () {
                                                e = !1
                                            }, 1300),
                                                o.preventDefault()
                                        }
                                },
                                { passive: !1 }
                            )
                    })(),
                    window.addEventListener('resize', function () {
                        clearTimeout(s), (s = setTimeout(p, 120))
                    })
            }
        }
    } else console.error('Требуется Swiper, gsap и ScrollTrigger')
    function c () {
        const t = i.activeIndex,
            r = e.slides[t],
            o = r ? r.getAttribute('data-month') : null
        if (
            (document
                .querySelectorAll('.year')
                .forEach(e => e.classList.remove('year--active')),
            o)
        ) {
            const e = document.querySelector(`.year[data-year="${o}"]`)
            e && e.classList.add('year--active')
        }
    }
    function d (e, t) {
        if (l && l.scrollTrigger && !(r <= 1)) {
            var i = l.scrollTrigger
            if (
                (('number' == typeof i.start && 'number' == typeof i.end) ||
                    (ScrollTrigger.refresh(), (i = l.scrollTrigger)),
                'number' == typeof i.start && 'number' == typeof i.end)
            ) {
                var o = r - 1 == 0 ? 0 : e / (r - 1),
                    s = Math.round(i.start + o * (i.end - i.start)),
                    c =
                        window.pageYOffset ||
                        document.documentElement.scrollTop ||
                        document.body.scrollTop ||
                        0
                if (Math.abs(c - s) <= 2) {
                    ;(a.idx = e), (n = e)
                    try {
                        l.progress(o, !1)
                    } catch (e) {}
                } else {
                    ;(a.idx = e), (n = e)
                    try {
                        l.progress(o, !1)
                    } catch (e) {}
                    t
                        ? window.scrollTo(0, s)
                        : window.scrollTo({
                              top: s,
                              left: 0,
                              behavior: 'smooth'
                          })
                }
            }
        }
    }
    function p () {
        ;(r = i.slides.length || r), ScrollTrigger.refresh()
    }
}
$(document).ready(function () {
    sliderServices(),
        planGallery(),
        sliderPlanMob(),
        sliderAboutAdvantages(),
        sliderHouseMain(),
        sliderArticleNews(),
        sliderStages(),
        $('.burger').click(function () {
            $(this).toggleClass('burger--active'),
                $('.menu').toggleClass('menu--active'),
                $('body').toggleClass('fixed-body')
        }),
        $('.btn-animation').mouseenter(function (e) {
            var t = $(this),
                i = t.find('.circle'),
                r = t.offset(),
                o = e.pageX - r.left,
                s = e.pageY - r.top
            i.css({ top: s + 'px', left: o + 'px' })
        }),
        $('.btn-animation').mousemove(function (e) {
            var t = $(this),
                i = t.find('.circle'),
                r = t.offset(),
                o = e.pageX - r.left,
                s = e.pageY - r.top
            i.css({ top: s + 'px', left: o + 'px' })
        })
    let e = !1
    $('.form').on('submit', function (t) {
        t.preventDefault(), (e = !0)
        let i = !0
        $(this)
            .find('.form-group input')
            .each(function () {
                const e = $(this),
                    t = e.closest('.form-group')
                '' === e.val().trim()
                    ? (t.addClass('form-group--active'), (i = !1))
                    : t.removeClass('form-group--active')
            })
    }),
        $('.form-group input').on('input', function () {
            if (e) {
                const e = $(this),
                    t = e.closest('.form-group')
                '' === e.val().trim()
                    ? t.addClass('form-group--active')
                    : t.removeClass('form-group--active')
            }
        })
    var t = $('.up')
    function i () {
        $('.modal--active video').each(function () {
            this.pause(), (this.currentTime = 0)
        }),
            $('.modal').removeClass('modal--active'),
            $('body').removeClass('fixed-body2')
    }
    $(window).scroll(function () {
        $(window).scrollTop() > 300
            ? t.addClass('up--active')
            : t.removeClass('up--active')
    }),
        t.on('click', function (e) {
            e.preventDefault(), $('html, body').animate({ scrollTop: 0 }, 300)
        }),
        $('[data-modal]').click(function () {
            !(function (e) {
                $('#' + e).addClass('modal--active'),
                    $('body').addClass('fixed-body2')
            })($(this).attr('data-modal'))
        }),
        $('.modal').click(function () {
            i()
        }),
        $('._close-modal').click(function () {
            i()
        }),
        $('.modal__dialog').click(function (e) {
            e.stopPropagation()
        }),
        $('.hover__pag-item').mouseover(function () {
            let e = $(this).attr('data-tab-path')
            $(this)
                .parents('.hover__slide')
                .find('.hover__pag-item')
                .removeClass('hover__pag-item--active'),
                $(this).addClass('hover__pag-item--active'),
                $(this)
                    .parents('.hover__slide')
                    .find('.hover__img')
                    .removeClass('hover__img--active'),
                $(this)
                    .parents('.hover__slide')
                    .find(`.hover__img[data-tab-path="${e}"]`)
                    .addClass('hover__img--active'),
                $(this)
                    .parents('.hover__slide')
                    .find('.pagination-bullet')
                    .removeClass('pagination-bullet--active'),
                $(this)
                    .parents('.hover__slide')
                    .find(`.pagination-bullet[data-tab-path="${e}"]`)
                    .addClass('pagination-bullet--active')
        }),
        $('.tab').click(function () {
            let e = $(this).attr('data-tab-path')
            $(this).siblings('.tab').removeClass('tab--active'),
                $(this).addClass('tab--active'),
                $(this)
                    .parents('.tabs-inner')
                    .find('.tab__content')
                    .removeClass('tab__content--active'),
                $(this)
                    .parents('.tabs-inner')
                    .find(`.tab__content[data-content-path="${e}"]`)
                    .addClass('tab__content--active')
        })
}),
    document.addEventListener('DOMContentLoaded', () => {
        const e = gsap.utils.toArray('.services .section-top')
        e.forEach(e => {
            gsap.set(e, {
                opacity: 0,
                y: 80,
                transformOrigin: 'center center',
                willChange: 'transform, opacity'
            })
        })
        const t = new IntersectionObserver(
            (e, t) => {
                e.forEach(e => {
                    const i = e.target
                    e.isIntersecting &&
                        (i._gsapTriggered ||
                            ((i._gsapTriggered = !0),
                            gsap.to(i, {
                                opacity: 1,
                                y: 0,
                                ease: 'power3.out',
                                duration: 1.5,
                                scrollTrigger: {
                                    trigger: i,
                                    start: 'top 80%',
                                    end: 'top 40%'
                                }
                            }),
                            t.unobserve(i)))
                })
            },
            { threshold: 0.05 }
        )
        e.forEach(e => t.observe(e))
    })
const serviceTimeline = gsap.timeline({ paused: !0 }),
    observerServices = new IntersectionObserver(
        (e, t) => {
            e.forEach(e => {
                e.isIntersecting &&
                    (serviceTimeline.clear(),
                    document
                        .querySelectorAll('.services__slider .swiper-slide')
                        .forEach((e, t) => {
                            serviceTimeline.to(e, {
                                opacity: 1,
                                y: 0,
                                duration: 0.6,
                                ease: 'power2.out'
                            })
                        }),
                    serviceTimeline.play(),
                    t.disconnect())
            })
        },
        { threshold: 0.5 }
    ),
    servicesSection = document.querySelector('.services__slider')
servicesSection && observerServices.observe(servicesSection),
    document.addEventListener('DOMContentLoaded', () => {
        const e = gsap.utils.toArray('.area2__inner')
        e.forEach(e => {
            gsap.set(e, {
                opacity: 0,
                y: 80,
                transformOrigin: 'center center',
                willChange: 'transform, opacity'
            })
        })
        const t = new IntersectionObserver(
            (e, t) => {
                e.forEach(e => {
                    const i = e.target
                    e.isIntersecting &&
                        (i._gsapTriggered ||
                            ((i._gsapTriggered = !0),
                            gsap.to(i, {
                                opacity: 1,
                                y: 0,
                                ease: 'power3.out',
                                duration: 1.5,
                                scrollTrigger: {
                                    trigger: i,
                                    start: 'top 80%',
                                    end: 'top 40%'
                                }
                            }),
                            t.unobserve(i)))
                })
            },
            { threshold: 0.05 }
        )
        e.forEach(e => t.observe(e))
    }),
    document.addEventListener('DOMContentLoaded', () => {
        if (document.querySelector('.house-main__group')) {
            const e = gsap.utils.toArray('.house-main__group')
            gsap.set(e, { opacity: 0, y: 60, willChange: 'transform, opacity' }),
                gsap.to(e, {
                    opacity: 1,
                    y: 0,
                    duration: 1.5,
                    ease: 'power3.out',
                    stagger: 0.06,
                    overwrite: !0
                })
        }
    }),
    document.addEventListener('DOMContentLoaded', () => {
        const e = gsap.utils.toArray('.house-plan .section-top')
        e.forEach(e => {
            gsap.set(e, {
                opacity: 0,
                y: 80,
                transformOrigin: 'center center',
                willChange: 'transform, opacity'
            })
        })
        const t = new IntersectionObserver(
            (e, t) => {
                e.forEach(e => {
                    const i = e.target
                    e.isIntersecting &&
                        (i._gsapTriggered ||
                            ((i._gsapTriggered = !0),
                            gsap.to(i, {
                                opacity: 1,
                                y: 0,
                                ease: 'power3.out',
                                duration: 1.5,
                                scrollTrigger: {
                                    trigger: i,
                                    start: 'top 80%',
                                    end: 'top 40%'
                                }
                            }),
                            t.unobserve(i)))
                })
            },
            { threshold: 0.05 }
        )
        e.forEach(e => t.observe(e))
    }),
    document.addEventListener('DOMContentLoaded', () => {
        const e = gsap.utils.toArray('.house-presentation__group')
        e.forEach(e => {
            gsap.set(e, {
                opacity: 0,
                y: 80,
                transformOrigin: 'center center',
                willChange: 'transform, opacity'
            })
        })
        const t = new IntersectionObserver(
            (e, t) => {
                e.forEach(e => {
                    const i = e.target
                    e.isIntersecting &&
                        (i._gsapTriggered ||
                            ((i._gsapTriggered = !0),
                            gsap.to(i, {
                                opacity: 1,
                                y: 0,
                                ease: 'power3.out',
                                duration: 1.5,
                                scrollTrigger: {
                                    trigger: i,
                                    start: 'top 80%',
                                    end: 'top 40%'
                                }
                            }),
                            t.unobserve(i)))
                })
            },
            { threshold: 0.05 }
        )
        e.forEach(e => t.observe(e))
    })
// Открытие модалки и автозапуск видео
document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-modal]')
    if (!btn) return

    e.preventDefault()

    const modalId = btn.getAttribute('data-modal')
    const modal = document.getElementById(modalId)
    if (!modal) return

    // тут твоя логика открытия (класс active, показ оверлея и т.п.)
    modal.classList.add('is-open')

    // находим видео и запускаем
    const video = modal.querySelector('video')
    if (video) {
        video.currentTime = 0 // по желанию — начать с начала
        video.play().catch(() => {
            // если браузер вдруг заругается — молча игнорируем
        })
    }
})
//# sourceMappingURL=../sourcemaps/main.min.js.map
